/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import { action } from '@ember/object';

interface CampaignWebhookUrlCopyArgs {
  campaign: CampaignModel;
  webhookUrl: string;
  analyticsSource?: string;
  isButtonDisabled?: boolean;
  showSpinner?: boolean;
}

export default class CampaignWebhookUrlCopy extends Component<CampaignWebhookUrlCopyArgs> {
  @service analytics!: AnalyticsService;

  @action
  onCopy() {
    this.analytics.track('campaign', 'webhook_url_copied', {
      model: this.args.campaign,
      source: this.args.analyticsSource,
    });
  }
}
